import { makeStyles } from 'tss-react/mui';

interface InputStyleProps {
  disabled?: boolean;
  error?: boolean;
  isOpen?: boolean; // for example when the dialog box is opened
}

export const useInputStyles = makeStyles<InputStyleProps>()((theme, { error, isOpen }) => ({
  /**
   * The input box is the gray bordered container that holds any kind of input
   * element.
   *
   * It can be:
   *
   * - text input
   * - select input
   * - color picker input
   *
   * It has no padding on the inside because it will vary depending on the
   * type of input. This is bare bones but is used to ensure consistent:
   *
   * - border
   * - height
   * - focus state
   * - hover state
   */
  inputBox: {
    '&:focus-within': {
      border: error
        ? `1px solid ${theme.palette.error.main}`
        : `1px solid ${theme.appColors.primary}`,
    },
    '&:hover': {
      backgroundColor: theme.appColors.hoverBackground,
    },
    border: error
      ? `1px solid ${theme.palette.error.main}`
      : isOpen
        ? `1px solid ${theme.appColors.primary}`
        : `1px solid ${theme.appColors.rule}`,
    borderRadius: 3,
    boxSizing: 'border-box',
    display: 'flex',
    height: theme.appSizes.inputHeight,
    position: 'relative',
  },
  /**
   * If there is text inside the input box, it will be styled with this class
   * for consistency. It can be text for:
   *
   * - text input
   * - select input
   */
  inputText: {
    fontFamily: theme.typography.fontFamily,
    fontSize: 14,
  },
}));
